<div class="signatur">
  @if (medSigneringsstoette()) {
    @if (viserSigneringsknapp()) {
      <button mat-raised-button color="primary" (click)="signer()" data-testid="signer-protokoll-knapp">
        {{ 'Signer' | translate }}
      </button>
    }
    @if (signatar().harSignert) {
      <mat-icon>check_circle</mat-icon>
      <span [innerHTML]="signeringsinformasjon()" data-testid="signeringsinformasjon"></span>
    }
  }
</div>
<div class="navn" data-testid="deltakernavn">{{ signatar().medlem.navn }}</div>
<div class="rolle">
  @for (rolle of signatar().aktiveMedlemsroller; track rolle.id; let erSiste = $last) {
    {{ rolle.tittel }}@if (!erSiste) {,}
  }
</div>
<div class="sett">
  @if (signatar().status !== statuser.deltatt) {
    {{ 'Protokoll sett'|translate }}
  }
</div>
